module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navi"
  }, [_c('el-row', {
    staticClass: "top-nav"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  }), _vm._v(" "), (_vm.isProd == 'N') ? _c('span', {
    staticClass: "name",
    staticStyle: {
      "line-height": "15px",
      "padding-top": "7px"
    }
  }, [_vm._v("新美云平台\n            "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "text-align": "center",
      "color": "red"
    }
  }, [_vm._v("[ 测 试 版 ]")])]) : _c('span', {
    staticClass: "name",
    staticStyle: {
      "line-height": "15px",
      "padding-top": "10px"
    }
  }, [_vm._v("新美云平台\n            "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "text-align": "center",
      "color": "red"
    }
  })]), _vm._v(" "), _c('ul', _vm._l((_vm.nodes), function(item) {
    return (item.component == 'HomeView') ? _c('li', {
      class: {
        'active': _vm.$route.matched[0].name == item.name,
        'disable': item.disable
      },
      on: {
        "click": function($event) {
          return _vm.pushHandle(item.disable, item.path)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.isShowNoPass,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowNoPass = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("您没有此项目菜单查看权限！")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isShowNoPass = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cb4f8ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Navi.vue
// module id = 1674
// module chunks = 471